import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

// Single payment checkout link url will look like this: /checkout/single-payment-checkout?wires_quantity=<quantity>
export const getSinglePaymentCheckoutPath = () => {
  return urlHelper(`/checkout/single-payment-checkout`);
};
